<template>
  <div class="content">
    <!-- <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ ctitle }}</h3> -->
    <div class="pageHeader">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane :label="`我的${$store.state.themeTitle}项目`" name="1">
        </el-tab-pane>
        <el-tab-pane v-if="$until.checkPrmissions('courseProjectsMangeTeacher', 'addEditDel')"
          :label="`${$store.state.themeTitle}项目申请`" name="2">
        </el-tab-pane>
      </el-tabs>
    </div>
    <template v-if="activeName == '1'">
      <CorseProjectsManageModule ctitle="" :isAdmin="2" />
    </template>
    <template v-if="activeName == '2'">
      <CourseProjectsMangeLast/>
    </template>
  </div>
</template>

<script>
import CorseProjectsManageModule from "./components/corseProjectsManageModule";
import CourseProjectsMangeLast from "./components/courseProjectsMangeLast";

export default {
  components: {
    CorseProjectsManageModule,
    CourseProjectsMangeLast,
  },
  name: 'equipmentInto',
  data() {
    return {
      activeName: '1',
    };
  },
  created() {
    // 
  },
  mounted() {
  },
  methods: {
    handleTabClick(val) {
    },

  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.pageHeader {
  padding-bottom: 5px;
}
</style>
